import { globalGetService, globalPostService, globalPutService,globalDeleteService } from '../../../utils_v2/globalApiServices';
import { toastFlashMessage } from '../../../utils';
import { fieldValidation } from '../../../utils_v2/formValidation';
import { checkApiStatus } from '../../../utils_v2';
import { errorCode } from './';
export function getInductionCondListApi(props={}, query={}){
  globalGetService(`contracts/${props.params.contract_slug}/induction-condition-items/`, query)
  .then(response => {
    if(checkApiStatus(response)){
      this.setState({
        list: response.data.data
      })
    }
    this.setState({skeletonLoader:false});
  })
}
export function getInductionCondApi(props={}, id, mode){
  this.setState({pageLoader:true});
  globalGetService(`contracts/${props.params.contract_slug}/induction-condition-items/${id}/`)
  .then(response => {
    if(checkApiStatus(response)){
      this.setState({ inductionCond:response.data.data, error:{}, modal:true,mode:mode === 'V'?'view':'edit'})
    }
    this.setState({pageLoader:false});
  })
}
export function addEditInductionCondApi(props={}, data={}){
  return new Promise(
    function(resolve, reject){
      if(data.id){
        globalPutService(`contracts/${props.params.contract_slug}/induction-condition-items/${data.id}/`, data)
        .then(response => {
          resolve(response);
        })
      }else{
        globalPostService(`contracts/${props.params.contract_slug}/induction-condition-items/`, data)
        .then(response => {
          resolve(response);
        })
      }
    }
  )
}
export function deleteInductionCondApi(props,deleteItem) {
  this.setState({pageLoader:true});
  globalDeleteService(`contracts/${props.params.contract_slug}/induction-condition-items/${deleteItem.data.id}/`)
    .then(response => {
      if (checkApiStatus(response)) {
        this.setState(prevState => ({
          ...prevState,
          list: prevState.list.filter((item, index) => item.id != deleteItem.data.id),
          deleteItem:{modal:false, data:null}
        }))
        toastFlashMessage(response?.data?.message, 'success')
      } else {
        toastFlashMessage(response?.data?.message, 'error')
      }
      this.setState({pageLoader:false});
    })
}

